export const getAdobeAnalyticsEventObject = (
  eventName = false,
  eventInfo = false,
  action = false
) => {
  let eventObj = {};

  if (eventName) {
    eventObj = { ...eventObj, event: eventName };
  }
  if (eventInfo) {
    eventObj = { ...eventObj, eventInfo };
  }
  if (action) {
    eventObj = { ...eventObj, action };
  }

  return eventObj;
};

export const getAdobeAnalyticsCustomLinkObj = (
  linkTitle,
  linkModule,
  targetURL
) => {
  return {
    link: {
      linkTitle,
      linkModule,
      targetURL,
    },
  };
};

export const getAdobeAnalyticsContentObj = ({
  contClick = "",
  contID = "",
  contLang = "en",
  contName = "",
  contType = null,
  contTags = "",
  contTopic = "",
  contSource = "",
  contIndustry = "",
}) => {
  return {
    cont: {
      contClick,
      contID,
      contLang,
      contName,
      contType,
      contTags,
      contTopic,
      contSource,
      contIndustry,
    },
  };
};

export const getAdobeAnalyticsContentPageObj = ({
  contClick = ""
}) => {
  return {
    cont: {
      contClick
    },
  };
};
export const getAdobeAnalyticsDownloadObj = ({
  fileName = null,
  fileLanguage = null,
}) => {
  return {
    fileName,
    fileLanguage,
  };
};

export const getAdobeAnalyticsPlayListObj = (
  playlistName = null
) => {
  return playlistName
};
export const getAdobeAnalyticsSocailListObj = (
  socialTool = null
) => {
  return socialTool
};
export const getAdobeAnalyticsPaginationObj = (
  paginationStep = null
) => {
  return paginationStep
};

export const getAdobeAnalyticsSocialObj = ({
  contID = "",
  contLang = "",
  contName = "",
  contType = "",
  contTags = "",
  contTopic = "",
  contSource = "",
  contIndustry = "",
}) => {
  return {
    cont: {
      contID,
      contLang,
      contName,
      contType,
      contTags,
      contTopic,
      contSource,
      contIndustry,
    },
  };
};
